import { Component } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { UiFeedbackHostComponent } from './shared/ui/ui-feedback.host';

@Component({
  selector: 'app-root',
  standalone: true,
  imports: [RouterOutlet, UiFeedbackHostComponent],
  template: `
    <router-outlet />
    <app-ui-feedback />
  `,
})
export class App {}
